var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 7.26245C13.9909 7.26246 12.0191 7.94142 10.6318 9.25075C8.70467 11.0695 8.52636 14.0063 9.72492 17.1019C10.8664 20.05 13.1938 22.9266 15.9997 24.6312C18.8056 22.9266 21.1332 20.0499 22.2746 17.1019C23.4732 14.0063 23.2948 11.0694 21.3676 9.25068C19.9802 7.94139 18.0084 7.26244 15.9997 7.26245ZM15.9996 5.76245C18.3246 5.76244 20.6864 6.54535 22.3971 8.15976C24.9644 10.5825 24.9748 14.2824 23.6734 17.6435C22.3645 21.0242 19.6581 24.3027 16.3674 26.1536L15.9997 26.3604L15.632 26.1536C12.3414 24.3027 9.63506 21.0242 8.32611 17.6435C7.02478 14.2825 7.03514 10.5826 9.60224 8.15986C11.3129 6.54539 13.6747 5.76246 15.9996 5.76245ZM16 10.7499C14.7573 10.7499 13.75 11.7573 13.75 12.9999C13.75 14.2426 14.7573 15.2499 16 15.2499C17.2426 15.2499 18.25 14.2426 18.25 12.9999C18.25 11.7573 17.2426 10.7499 16 10.7499ZM12.25 12.9999C12.25 10.9289 13.9289 9.24992 16 9.24992C18.0711 9.24992 19.75 10.9289 19.75 12.9999C19.75 15.071 18.0711 16.7499 16 16.7499C13.9289 16.7499 12.25 15.071 12.25 12.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ca62cf79c44dea6404e33f0c7fc539b8.svg";
export { ForwardRef as ReactComponent };